import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { SearchFilters, OrderByOption } from '../types';

interface SortByControlProps {
  filters: SearchFilters;
  onFiltersChange: (filters: Partial<SearchFilters>) => void;
}

const ORDER_BY_OPTIONS: { value: OrderByOption; label: string }[] = [
  { value: 'quality', label: 'Quality' },
  { value: 'grade', label: 'Grade' },
  { value: 'length', label: 'Length' },
  { value: 'name', label: 'Name' },
];

export default function SortByControl({
  filters,
  onFiltersChange,
}: SortByControlProps) {
  const [isOpen, setIsOpen] = useState(false);

  const getCurrentLabel = () => {
    if (!filters.orderBy) return 'Quality';
    const option = ORDER_BY_OPTIONS.find(opt => opt.value === filters.orderBy);
    return option ? option.label : 'Quality';
  };

  const handleOptionClick = (orderBy: OrderByOption) => {
    onFiltersChange({
      orderBy: orderBy || undefined,
    });
    setIsOpen(false);
  };

  return (
    <div className="relative">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center gap-1 text-sm text-gray-600 hover:text-gray-800 transition-colors"
      >
        <span>Sort By: {getCurrentLabel()}</span>
        <ChevronDown className={`w-3 h-3 transition-transform ${isOpen ? 'rotate-180' : ''}`} />
      </button>

      {isOpen && (
        <>
          {/* Backdrop */}
          <div 
            className="fixed inset-0 z-10" 
            onClick={() => setIsOpen(false)}
          />
          
          {/* Dropdown */}
          <div className="absolute right-0 top-full mt-1 bg-white border border-gray-200 rounded-md shadow-lg z-20 min-w-32">
            <div className="py-1">
              <button
                onClick={() => handleOptionClick('quality' as OrderByOption)}
                className={`w-full text-left px-3 py-2 text-sm hover:bg-gray-50 ${
                  !filters.orderBy ? 'bg-primary-50 text-primary-700' : 'text-gray-700'
                }`}
              >
                Quality
              </button>
              <button
                onClick={() => handleOptionClick('grade' as OrderByOption)}
                className={`w-full text-left px-3 py-2 text-sm hover:bg-gray-50 ${
                  filters.orderBy === 'grade' ? 'bg-primary-50 text-primary-700' : 'text-gray-700'
                }`}
              >
                Grade
              </button>
              <button
                onClick={() => handleOptionClick('length' as OrderByOption)}
                className={`w-full text-left px-3 py-2 text-sm hover:bg-gray-50 ${
                  filters.orderBy === 'length' ? 'bg-primary-50 text-primary-700' : 'text-gray-700'
                }`}
              >
                Length
              </button>
              <button
                onClick={() => handleOptionClick('name' as OrderByOption)}
                className={`w-full text-left px-3 py-2 text-sm hover:bg-gray-50 ${
                  filters.orderBy === 'name' ? 'bg-primary-50 text-primary-700' : 'text-gray-700'
                }`}
              >
                Name
              </button>
            </div>
          </div>
        </>
      )}
    </div>
  );
}
